import React, { Component } from 'react'
import { Link } from 'react-router-dom'

export default class Logout extends Component {
    constructor(props) {
        super(props)
        localStorage.removeItem("user")
        localStorage.removeItem("shared_user_id")
        localStorage.removeItem("shared_invoice_id")
        localStorage.removeItem("shared_event_id")
        localStorage.removeItem("resetEmail")
        localStorage.removeItem("resetOtp")
        sessionStorage.clear()
    }
  render() {
    return (
      <div>
        <h1>You have been logged-out</h1>
        <Link to="/sign-in">Login again</Link>
      </div>
    )
  }
}
